(() => {
  const root = document.querySelector('[data-ale-journal-article]');
  if (!root) return;
  const body = root.querySelector('[data-journal-article-body]');
  if (!body) return;

  const normalize = (text) =>
    (text || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .replace(/[:.!]+$/, '')
      .toLowerCase();

  /* HIGH NOTES: use the configured display line or the first opening source line. */
  const highNotes = root.querySelector('.ale-letter-high-notes');
  if (highNotes && !highNotes.querySelector('.ale-letter-high-notes__headline')) {
    const label = highNotes.querySelector('.ale-letter-high-notes__label');
    const configuredHeading = (root.dataset.aleHighNotesHeading || '').trim();
    const firstCopy = [...highNotes.children].find((el) =>
      el !== label && el.matches('p, div') && (el.textContent || '').trim()
    );
    const headingText = configuredHeading || (firstCopy?.textContent || '').trim();
    if (label && headingText) {
      const heading = document.createElement('h2');
      heading.className = 'ale-letter-high-notes__headline';
      heading.textContent = headingText;
      label.insertAdjacentElement('afterend', heading);
      if (firstCopy) {
        const source = normalize(firstCopy.textContent);
        const display = normalize(headingText);
        if (!configuredHeading || source === display || source.endsWith(display)) firstCopy.remove();
      }
    }
  }

  /* QA bridge for legacy CAL source: convert the approved short lines into the specimen bullet treatment. */
  const bulletTexts = ['nib width matters', 'nib wetness matters', 'ink formula and flow matter'];
  const directParagraphs = [...body.children].filter((el) => el.matches('p'));
  const bulletNodes = bulletTexts.map((wanted) => directParagraphs.find((el) => normalize(el.textContent) === wanted));
  if (bulletNodes.every(Boolean) && !body.querySelector('.ale-letter-bullet-list')) {
    const first = bulletNodes[0];
    const list = document.createElement('ul');
    list.className = 'ale-letter-bullet-list';
    first.parentNode.insertBefore(list, first);
    bulletNodes.forEach((p) => {
      const li = document.createElement('li');
      li.innerHTML = p.innerHTML;
      list.appendChild(li);
      p.remove();
    });
  }

  /* Legacy numbered H3s become the 01 / 02 process list used in the specimen. */
  const firstNumbered = [...body.children].find((el) => el.matches('h3') && /^\s*1[.)]\s+/.test(el.textContent || ''));
  if (firstNumbered && !body.querySelector('.ale-letter-process-list')) {
    const process = document.createElement('ol');
    process.className = 'ale-letter-process-list';
    firstNumbered.parentNode.insertBefore(process, firstNumbered);
    let node = firstNumbered;
    let count = 0;
    while (node && !node.matches('h2')) {
      if (!(node.matches('h3') && /^\s*\d+[.)]\s+/.test(node.textContent || ''))) break;
      const heading = node;
      const title = (heading.textContent || '').replace(/^\s*\d+[.)]\s+/, '').trim();
      let next = heading.nextElementSibling;
      const li = document.createElement('li');
      const content = document.createElement('div');
      const strong = document.createElement('strong');
      strong.className = 'ale-letter-process-list__title';
      strong.textContent = title;
      content.appendChild(strong);
      const detail = document.createElement('div');
      detail.className = 'ale-letter-process-list__body';
      heading.remove();
      while (next && !next.matches('h2') && !(next.matches('h3') && /^\s*\d+[.)]\s+/.test(next.textContent || ''))) {
        const current = next;
        next = next.nextElementSibling;
        detail.appendChild(current);
      }
      content.appendChild(detail);
      li.appendChild(content);
      process.appendChild(li);
      count += 1;
      node = next;
    }
    if (count < 2) process.replaceWith(...process.childNodes);
  }

  /* PUT SIMPLY: preserve the source sentence; change only its editorial treatment. */
  if (!body.querySelector('.ale-letter-callout--put-simply')) {
    const target = [...body.children].find((el) =>
      el.matches('p') && normalize(el.textContent).startsWith('the page does more than hold the words')
    );
    if (target) {
      const callout = document.createElement('section');
      callout.className = 'ale-letter-callout ale-letter-callout--put-simply';
      const label = document.createElement('p');
      label.className = 'ale-letter-callout__label ale-journal-put-simply';
      label.textContent = 'PUT SIMPLY';
      const copy = document.createElement('p');
      copy.innerHTML = target.innerHTML;
      callout.append(label, copy);
      target.replaceWith(callout);
    }
  }

  /* PULL QUOTE: approved CAL sentence, unchanged, promoted into the black editorial interruption. */
  if (!body.querySelector('.ale-letter-pull-quote')) {
    const target = [...body.children].find((el) =>
      el.matches('p') && normalize(el.textContent).startsWith('the goal is not to find one universally correct pairing')
    );
    if (target) {
      const quote = document.createElement('blockquote');
      quote.className = 'ale-letter-pull-quote';
      const label = document.createElement('p');
      label.className = 'ale-letter-pull-quote__label';
      label.textContent = 'A LOVELY REMINDER';
      const copy = document.createElement('p');
      copy.innerHTML = target.innerHTML;
      quote.append(label, copy);
      target.replaceWith(quote);
    }
  }

  /* TOC: keep the specimen look, but make the entire header an accessible expandable summary. */
  const toc = root.querySelector('[data-journal-toc]');
  if (toc) {
    const count = toc.querySelectorAll('[data-journal-toc-list] > li').length;
    const countLabel = toc.querySelector('[data-ale-toc-count]');
    const symbol = toc.querySelector('[data-ale-toc-symbol]');
    if (countLabel) countLabel.textContent = `${count} ${count === 1 ? 'SECTION' : 'SECTIONS'}`;
    const sync = () => { if (symbol) symbol.textContent = toc.open ? '−' : '+'; };
    sync();
    toc.addEventListener('toggle', sync);
  }
})();
